"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class TransactionMapper {
    toDomain(result) {
        const date = lodash_1.default.get(result, "node.date");
        const id = lodash_1.default.get(result, "node.id");
        const virtual = lodash_1.default.get(result, "node.virtual");
        const pos = {
            id: lodash_1.default.get(result, "node.pos.id"),
            name: lodash_1.default.get(result, "node.pos.name"),
            type: lodash_1.default.get(result, "node.pos.type"),
        };
        const total = {
            amount: lodash_1.default.get(result, "node.total.amount"),
            currency: lodash_1.default.get(result, "node.total.currency"),
        };
        const oldBalance = {
            amount: lodash_1.default.get(result, "node.oldBalance.amount"),
            currency: lodash_1.default.get(result, "node.oldBalance.currency"),
        };
        const newBalance = {
            amount: lodash_1.default.get(result, "node.newBalance.amount"),
            currency: lodash_1.default.get(result, "node.newBalance.currency"),
        };
        const refill = {
            amount: lodash_1.default.get(result, "node.refill.amount"),
            currency: lodash_1.default.get(result, "node.refill.currency"),
        };
        const isCredit = lodash_1.default.get(result, "node.isCredit", false);
        return {
            date,
            id,
            virtual,
            pos,
            total,
            oldBalance,
            newBalance,
            refill,
            isCredit
        };
    }
}
exports.TransactionMapper = TransactionMapper;
